 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1bfc9850","1":"6ba866124f1cc0852415177fa8137e656b1b5383","2":"styles","3":"f57843381cf3498dcb6fc8f5d25915132836cd9d","4":"0c4c2da88f46d3bd53139bc3fa4dbf1cf1bea610","5":"206e16d1e6b70b06c8edabff42b2a0e246d04ba0","6":"9dee36caaec0269c1f0e24a503650f0ce4ab8145","7":"b9f67b1fc2879147d50fb862ac17b0f2b7ef6d50","8":"00e379d7f690afb3edb495f5fb2da860d5cc1eba","9":"74e15a17812acdeb5dacaa448628c2295589ce02","10":"955a21ab1dfc5584bfc785fed02f011e6c6913ca","11":"adae204a6355a3ecf55e529e07aec7ad6c0b153c","14":"component---node-modules-gatsby-plugin-offline-app-shell-js","15":"component---src-pages-404-js","16":"component---src-pages-about-js","17":"component---src-pages-academy-js","18":"component---src-pages-career-js","19":"component---src-pages-consultation-js","20":"component---src-pages-contact-js","21":"component---src-pages-dental-form-js","22":"component---src-pages-digital-dentistry-js","23":"component---src-pages-engineering-js","24":"component---src-pages-gallery-js","25":"component---src-pages-index-js","26":"component---src-pages-medical-js","27":"component---src-pages-medical-upload-js","28":"component---src-pages-metal-print-form-js","29":"component---src-pages-metalmaterial-js","30":"component---src-pages-metalprinter-js","31":"component---src-pages-polyprinter-js","32":"component---src-pages-printer-js","33":"component---src-pages-research-js","34":"component---src-pages-scanner-js","35":"component---src-pages-software-fusion-js","36":"component---src-pages-software-js","37":"component---src-pages-software-simufact-js","38":"component---src-pages-stories-js","39":"component---src-pages-training-advance-js","40":"component---src-pages-training-amdesigner-js","41":"component---src-pages-training-amoperator-js","42":"component---src-pages-training-amprocess-js","43":"component---src-pages-training-basic-js","44":"component---src-pages-training-build-js","45":"component---src-pages-training-custom-js","46":"component---src-pages-training-design-js","47":"component---src-pages-training-js","48":"component---src-templates-story-js"}[chunkId]||chunkId) + "-" + {"0":"c9fb578f082d881a1827","1":"48f2c418c3e15515d15b","2":"7d4153d260c0197f0043","3":"b03620064c01ba65a753","4":"84bde3401862ef60423d","5":"e20f620a749d77ab0fd2","6":"34531f76576d99501fee","7":"f4e1a3364eac33f2e567","8":"5eb4afb865868da86e6a","9":"a62af40bdff8c5fc093f","10":"7437572b97e84533d453","11":"8714bc71a0a259c7a1ff","14":"81e6ca04e97c1fff23a7","15":"44dcd9a7fc1c6f0a077d","16":"a16ff538ffcad2ec6522","17":"b66168bff7b8ac2b7fb4","18":"ea4711a167b2a3ae53af","19":"78d6f2b53332e7b09a4a","20":"2c964eb8a4ab402cbe04","21":"332637b575345d4064b9","22":"38af76e510e0b3e18c73","23":"b4d17b8f44674b30a39b","24":"8afe1e854932ee31c833","25":"d5a2c0694ccd15e52cd8","26":"ec1fa7dcd8325b814b80","27":"287d7eb60e73a08e59c1","28":"a53921e9254b9e88bc90","29":"b6d360720174d6e0fb77","30":"cbbf7ff11e4f7dc98c29","31":"4d15f1533309575c5141","32":"c44ded0ec14a2ad54344","33":"cfdd71070912f67cc201","34":"9cb31c79f932646242bf","35":"f88d690a5b054d073c43","36":"35876e917101117e0a7f","37":"c647094230b979674f3a","38":"d0e50d9aff7af3f1eb65","39":"9589a64f3cdb11a445b3","40":"4bcb4124945479d97a00","41":"c56c42a8703b6da3f585","42":"8bf43e0da31d97041f7c","43":"c1476affe1a4c4149ef3","44":"823aa32e3c8bef771577","45":"90de41399f36cd29b934","46":"a6f1727d5812e2a4991c","47":"41be24913fbac1e442ea","48":"947b9adb4729a804dc04"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"1bfc9850","1":"6ba866124f1cc0852415177fa8137e656b1b5383","2":"styles","3":"f57843381cf3498dcb6fc8f5d25915132836cd9d","4":"0c4c2da88f46d3bd53139bc3fa4dbf1cf1bea610","5":"206e16d1e6b70b06c8edabff42b2a0e246d04ba0","6":"9dee36caaec0269c1f0e24a503650f0ce4ab8145","7":"b9f67b1fc2879147d50fb862ac17b0f2b7ef6d50","8":"00e379d7f690afb3edb495f5fb2da860d5cc1eba","9":"74e15a17812acdeb5dacaa448628c2295589ce02","10":"955a21ab1dfc5584bfc785fed02f011e6c6913ca","11":"adae204a6355a3ecf55e529e07aec7ad6c0b153c","14":"component---node-modules-gatsby-plugin-offline-app-shell-js","15":"component---src-pages-404-js","16":"component---src-pages-about-js","17":"component---src-pages-academy-js","18":"component---src-pages-career-js","19":"component---src-pages-consultation-js","20":"component---src-pages-contact-js","21":"component---src-pages-dental-form-js","22":"component---src-pages-digital-dentistry-js","23":"component---src-pages-engineering-js","24":"component---src-pages-gallery-js","25":"component---src-pages-index-js","26":"component---src-pages-medical-js","27":"component---src-pages-medical-upload-js","28":"component---src-pages-metal-print-form-js","29":"component---src-pages-metalmaterial-js","30":"component---src-pages-metalprinter-js","31":"component---src-pages-polyprinter-js","32":"component---src-pages-printer-js","33":"component---src-pages-research-js","34":"component---src-pages-scanner-js","35":"component---src-pages-software-fusion-js","36":"component---src-pages-software-js","37":"component---src-pages-software-simufact-js","38":"component---src-pages-stories-js","39":"component---src-pages-training-advance-js","40":"component---src-pages-training-amdesigner-js","41":"component---src-pages-training-amoperator-js","42":"component---src-pages-training-amprocess-js","43":"component---src-pages-training-basic-js","44":"component---src-pages-training-build-js","45":"component---src-pages-training-custom-js","46":"component---src-pages-training-design-js","47":"component---src-pages-training-js","48":"component---src-templates-story-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"3ff794c8f7c60e2b0593","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
